/**
 * Follow-ups de cliente (central na Visão geral do CRM).
 * Coleção: crmFollowups/{id} = { clientId, clientNome, data (ms), obs, done, criadoEm, criadoPor }
 * Leads usam o campo followUpAt do próprio lead; aqui é só o follow-up de clientes.
 */

function msOf(ts) {
  if (!ts) return 0;
  if (typeof ts === 'number') return ts;
  if (typeof ts.toDate === 'function') return ts.toDate().getTime();
  return 0;
}

export function subscribeFollowups(callback) {
  const db = window._fbDb;
  if (!db || !window._fbCollection || !window._fbOnSnapshot) {
    callback([]);
    return () => {};
  }
  return window._fbOnSnapshot(
    window._fbCollection(db, 'crmFollowups'),
    snap => {
      const list = [];
      snap.forEach(d => list.push({ id: d.id, ...d.data() }));
      list.sort((a, b) => (Number(a.data) || 0) - (Number(b.data) || 0));
      callback(list);
    },
    () => callback([]),
  );
}

/**
 * `done: true` na criação = follow-up REGISTRADO, que já aconteceu (21/09). Nasce igual a um
 * agendado depois de concluído — `done` —, então a central da Visão geral o ignora e a lista
 * da proposta o mostra no histórico, sem lógica nova em nenhuma das duas.
 */
export async function createFollowup({ clientId, leadId, clientNome, data, obs, propostaId, gcalEventId, diaInteiro, done = false }) {
  const db = window._fbDb;
  const ref = window._fbCollection(db, 'crmFollowups');
  const docRef = await window._fbAddDoc(ref, {
    clientId: String(clientId || '').trim(),
    leadId: String(leadId || '').trim(),
    propostaId: String(propostaId || '').trim(),
    clientNome: String(clientNome || '').trim(),
    data: Number(data) || 0,
    obs: String(obs || '').trim(),
    done: !!done,
    diaInteiro: !!diaInteiro,
    gcalEventId: String(gcalEventId || '').trim(),
    criadoEm: window._fbServerTimestamp(),
    criadoPor: (window._currentUser && window._currentUser.uid) || '',
  });
  return docRef.id;
}

export async function updateFollowup(id, patch) {
  const db = window._fbDb;
  const ref = window._fbDoc(db, 'crmFollowups', id);
  const body = {};
  if (patch.data !== undefined) body.data = Number(patch.data) || 0;
  if (patch.obs !== undefined) body.obs = String(patch.obs).trim();
  if (patch.done !== undefined) body.done = !!patch.done;
  if (patch.gcalEventId !== undefined) body.gcalEventId = String(patch.gcalEventId || '').trim();
  await window._fbUpdateDoc(ref, body);
}

export async function deleteFollowup(id) {
  const db = window._fbDb;
  await window._fbDeleteDoc(window._fbDoc(db, 'crmFollowups', id));
}

export { msOf as followupMs };
